import React from 'react';
import SignUp from '../components/sign_up';

const App = () => {
  return (<SignUp />);
};

export default App;
